<h2 mat-dialog-title>Unregister User</h2>

<mat-dialog-content>
  <div class="p-4">
    <form>

        <div class="mce-form-section space-y-4">
            <p>
                Deleting your account will permanently remove your private data, projects and cables.
                This action cannot be undone.
            </p>

            <mat-checkbox [formField]="form.acknowledged"
                          required>
                I have read and understand that my account, private data, projects and cables will be deleted.
            </mat-checkbox>

            @if (viewState().otpSending) {
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            }

            @if (viewState().showOtpError) {
            <mce-info-message [type]="'error'">
                Unable to email a one time password. Please try again.
            </mce-info-message>
            }

            @if (viewState().showOtpInput) {

            <mce-info-message [type]="'information'">
                A one time password has been emailed to you. Enter it below to continue.
            </mce-info-message>

            <mat-form-field class="w-full">
                <mat-label>One time password</mat-label>
                <input matInput
                       [formField]="form.otp"
                       placeholder="Enter the one time password" />

                @for (error of form.otp().errors(); track error.kind ) {
                <mat-error>
                    {{ error.message }}
                </mat-error>
                }
            </mat-form-field>
            }
        </div>
    </form>
  </div>
</mat-dialog-content>

<div mat-dialog-actions>
  <div class="w-full">
    <mce-save-cancel [config]="saveCancelConfig()"
                     (action)="onSaveCancelAction($event)">
        <button matButton="elevated"
                color="warn"
                type="button"
                [disabled]="!viewState().enableDelete"
                (click)="onDeleteAccountClick()">
            <mat-icon>delete</mat-icon>Delete Account
        </button>
    </mce-save-cancel>
  </div>
</div>
